import { z } from "zod";

import { zFromJson } from "../zod";

function zAppConfig<
  UserRoleKey extends z.KeySchema,
  UserRoleValue extends z.ZodType<string, z.ZodTypeDef>,
>(userRoleEntry: [UserRoleKey, UserRoleValue]) {
  return z
    .object({
      VITE_FLAT_USER_ROLE_BY_USER_ROLE_ID: zFromJson(z.record(...userRoleEntry)),
      VITE_ADMIN_PANEL_ROUTE: z.string().nonempty(),
      VITE_HOST: z.string().url(),
    })
    .transform(
      ({ VITE_FLAT_USER_ROLE_BY_USER_ROLE_ID, VITE_HOST, VITE_ADMIN_PANEL_ROUTE }, ctx) => {
        if (!VITE_FLAT_USER_ROLE_BY_USER_ROLE_ID) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message:
              "Unexpected error: Value is undefined after all transformations, but it shouldn't be.",
          });
          return z.NEVER;
        }

        return {
          flatRoleByRoleId: VITE_FLAT_USER_ROLE_BY_USER_ROLE_ID,
          adminPanelRoute: VITE_ADMIN_PANEL_ROUTE,
          host: VITE_HOST,
        };
      },
    );
}
type AppConfig<
  UserRoleKey extends z.KeySchema,
  UserRoleValue extends z.ZodType<string, z.ZodTypeDef>,
> = z.infer<ReturnType<typeof zAppConfig<UserRoleKey, UserRoleValue>>>;

export { zAppConfig };
export type { AppConfig };
